import { FormControlLabel, Switch, Typography } from "@mui/material";
import { type Control, Controller, useWatch } from "react-hook-form";
import type { IModalActionForm, IModalActionResolver } from "../../logics/types";

export interface IModalActionFormSendCalendarEventProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
}
export const SendCalendarEvent = ({ control }: IModalActionFormSendCalendarEventProps) => {
  const [status] = useWatch({
    control,
    name: ["status"],
  });

  if (status !== "todo") {
    return null;
  }

  return (
    <Controller
      name="sendEventToOwner"
      control={control}
      render={({ field }) => (
        <FormControlLabel
          sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}
          control={
            <Switch
              sx={{ marginRight: -1 }}
              onChange={(_, checked) => field.onChange(checked)}
              checked={field.value}
              color="primary"
            />
          }
          label={<Typography>Envoyer un lien par mail pour créer l’évènement correspondant dans mon agenda</Typography>}
          labelPlacement="start"
        />
      )}
    />
  );
};
